<template>
  <div class="mt-8">
    <px-view-module-header module-name="Empresa" :breadcrumbs="breadcrumbs"/>
    <v-card class="rounded-card card-shadow mt-8">
      <v-card-text class="text--primary">
        <px-view-header-title title="Cadastro de usuários">
          <template v-slot:before>
            <v-btn class="mb-1 mr-1" icon x-large color="primary" @click="onClickBack">
              <v-icon>
                mdi-arrow-left
              </v-icon>
            </v-btn>
          </template>
        </px-view-header-title>
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              outlined
              hide-details
              label="Nome"
              class="required"
              maxlength="150"
              :error="$v.usuario.nome.$error"
              @blur="$v.usuario.nome.$touch()"
              v-model="usuario.nome"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              outlined
              hide-details
              label="CPF"
              class="required"
              v-mask="'###.###.###-##'"
              :error="$v.usuario.cpf.$error"
              @blur="$v.usuario.cpf.$touch()"
              v-model="usuario.cpf"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8">
            <v-text-field
              outlined
              hide-details
              label="E-mail"
              class="required"
              maxlength="150"
              :error="$v.usuario.email.$error"
              @blur="$v.usuario.email.$touch()"
              v-model="usuario.email"
            />
          </v-col>
          <v-col cols="12" sm="4">
            <v-text-field
              outlined
              hide-details
              label="Telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              v-model="usuario.telefone"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Senha"
              class="required"
              type="password"
              minlength="8"
              maxlength="30"
              :messages="passwordMessages"
              autocomplete="new-password"
              :error="$v.usuario.password.$error"
              @blur="$v.usuario.password.$touch()"
              v-model="usuario.password"
            />
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Repetir senha"
              class="required"
              type="password"
              minlength="8"
              maxlength="30"
              autocomplete="new-password"
              :error="$v.usuario.matchPassword.$error"
              @blur="$v.usuario.matchPassword.$touch()"
              v-model="usuario.matchPassword"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn depressed
                   class="rounded-tag-small normal-btn-text"
                   color="primary"
                   :loading="loading"
                   :disabled="$v.$invalid"
                   @click="onSave">
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  email, maxLength, minLength, required, sameAs,
} from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';
import { onlyNumbers } from '@/utils/regex-utils';
import { isValid } from '@/utils/validate-cpf';
import { isPasswordValid } from '@/utils/validate-password';
import FornecedorService from '@/api/fornecedor-service';
import UserService from '../usuario-service';

export default {
  data() {
    return {
      fornecedor: null,
      loading: false,
      passwordMessages: ['Deve possuir letra maiúscula, minúscula e números. Entre 8 e 30 caracteres'],
      breadcrumbs: [
        { text: 'Empresa' },
        {
          text: 'Usuários',
          to: '/usuarios',
        },
        { text: 'Cadastro de usuários' },
      ],
      usuario: {
        nome: null,
        cpf: null,
        email: null,
        telefone: null,
        password: null,
        matchPassword: null,
        isSystemAdmin: false,
        isTermoAceito: false,
      },
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.usuarios' });
    },
    getFornecedor() {
      FornecedorService.get()
        .then(({ data }) => {
          [this.fornecedor] = data;
        });
    },
    buildToSave() {
      const usuario = cloneDeep(this.usuario);
      usuario.cpf = onlyNumbers(usuario.cpf);
      return usuario;
    },
    onSave() {
      this.loading = true;
      UserService.save(this.fornecedor.id, this.buildToSave())
        .then(() => {
          this.$toast('Usuário criado', { color: 'success' });
          this.onClickBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getFornecedor();
  },
  validations: {
    usuario: {
      nome: {
        required,
      },
      cpf: {
        required,
        validateCpf(value) {
          return isValid(value);
        },
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(30),
        passwordValid(value) {
          return isPasswordValid(value);
        },
      },
      matchPassword: {
        required,
        sameAsPassword: sameAs('password'),
      },
    },
  },
};
</script>
